module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-splash"
  }, [_c('div', {
    staticClass: "do-splash__contanier"
  }, [_c('DoLogo', {
    attrs: {
      "id": "do-logo"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e62a5a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DoSplash.vue
// module id = 2038
// module chunks = 1